// extracted by mini-css-extract-plugin
export var brand = "_69-9";
export var compact = "_69-6";
export var extraSmall = "_69-7";
export var icon = "_69-0";
export var large = "_69-4";
export var light = "_69-1";
export var medium = "_69-5";
export var outline = "_69-b";
export var primaryDark = "_69-a";
export var primaryLight = "_69-8";
export var primaryModern = "_69-c";
export var success = "_69-2";
export var successSolid = "_69-3";